import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { environment } from "../../environments/environment";
import { createBrowserHistory } from "history";
import { ComponentType } from "react";

const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();

const appInsightsInstance = new ApplicationInsights({
    config: {
        connectionString: environment.APPLICATIONINSIGHTS_CONNECTION_STRING,
        extensions: [reactPlugin],
        enableAutoRouteTracking: true,
        extensionConfig: {
            [reactPlugin.identifier]: { history: browserHistory } // Automatically track route changes
        }
    }
});

appInsightsInstance.loadAppInsights();


export const appInsights = appInsightsInstance; // Export the ApplicationInsights instance
// export default (Component: ComponentType<unknown>) => withAITracking(reactPlugin, Component);
export default (Component: ComponentType<unknown>) => Component; // Return component as-is without tracking